// extracted by mini-css-extract-plugin
export default {"container":"Signup_container__LtlvZ"};